/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PermissionsCameraGroupsFilter = {
    /**
     * Number of results to return.
     */
    limit?: number;
    /**
     * Which field to use when ordering the results. Available fields: `id`
     */
    ordering?: string;
}
export const EmptyPermissionsCameraGroupsFilter: PermissionsCameraGroupsFilter = {
    limit: 20,
    ordering: '-id',
}